


















import 'dropzone/dist/dropzone.css';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Dropzone from 'dropzone';
import { mapGetters } from 'vuex';

Dropzone.autoDiscover = false;

@Component({
  computed: mapGetters({
    token: 'accessToken'
  })
})
export default class DragUpload extends Vue {
  @Prop({ required: false, type: String, default: undefined })
  private acceptFileType!: string;

  @Prop({
    required: false,
    type: String,
    default: 'Drag your file(s) or a folder here to upload.'
  })
  private uploadInstructions!: string;

  @Prop({ required: false, type: Boolean, default: true })
  private showSectionSplitter!: boolean;

  @Prop({ required: true, type: String, default: '' })
  private postUrl!: string;

  @Prop({ required: false, type: Object })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private modelToSend!: any;

  @Prop({ required: false, type: Boolean, default: false })
  private autoProcessQueue!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private emitBase64AddFile!: boolean;

  @Prop({ required: false, type: Number, default: 1 })
  private maxFiles!: number;

  private token!: string;

  private fileReady = false;

  private wssDropzone!: Dropzone;

  onSending(
    file: Dropzone.DropzoneFile,
    xhr: XMLHttpRequest,
    formData: FormData
  ) {
    if (this.modelToSend) {
      // append each property to the data sent on the wire
      for (const key in this.modelToSend) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.modelToSend.hasOwnProperty(key)) {
          const element = this.modelToSend[key];
          if (element) {
            formData.append(key, element);
          }
        }
      }
    }
  }

  handleReaderLoad(ev: ProgressEvent<FileReader>) {
    if (ev.target && ev.target.result) {
      this.$emit(
        'fileAddedBase64',
        (ev.target.result as string).replace('data:image/jpeg;base64,', '')
      );
    }
  }

  onAddedFile(fileAdded: Dropzone.DropzoneFile) {
    // emit the file
    this.$emit('fileAdded', fileAdded.name);
    this.fileReady = true;

    if (this.emitBase64AddFile) {
      const rdr = new FileReader();
      rdr.onload = this.handleReaderLoad;
      rdr.readAsDataURL(fileAdded);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSuccess(file: Dropzone.DropzoneFile, itemCreated: any) {
    this.fileReady = false;
    this.$emit('success', itemCreated);
  }

  onError(file: Dropzone.DropzoneFile, response: string | Error) {
    this.wssDropzone.removeFile(file);
    this.fileReady = false;
    this.$emit('error', response);
  }

  private mounted() {
    const currentDz = this.$refs.dropZone as HTMLElement;
    this.wssDropzone = new Dropzone(currentDz, {
      paramName: 'Photo',
      acceptedFiles: this.acceptFileType,
      autoProcessQueue: this.autoProcessQueue,
      maxFiles: this.maxFiles,
      headers: { Authorization: 'Bearer ' + this.token },
      url: this.postUrl
    });

    this.wssDropzone.on('sending', this.onSending);
    this.wssDropzone.on('addedfile', this.onAddedFile);
    this.wssDropzone.on('success', this.onSuccess);
    this.wssDropzone.on('error', this.onError);
    this.wssDropzone.on('processing', () => {
      // enable autoProcessQueue to ensure that all of the items in the queue are processed after the initial upload
      // https://github.com/dropzone/dropzone/issues/253#issuecomment-22184190
      this.wssDropzone.options.autoProcessQueue = true;
    });
    this.wssDropzone.on('queuecomplete', () => {
      this.wssDropzone.options.autoProcessQueue = false;
      this.$emit('allFilesUploaded');
    });
  }

  @Watch('token')
  private handleTokenChanged(newToken: string) {
    this.wssDropzone.options.headers = { Authorization: 'Bearer ' + newToken };
  }

  /**
   * Process the upload queue. If there is a modelToSend bound, send all of its properties too.
   */
  public processUploadQueue() {
    this.wssDropzone.processQueue();
  }
}
